import type { IMember, MemberRole } from '../types/organisation';

export interface StoredUserSnapshot {
  userId: string;
  email?: string;
  displayName?: string;
  userRole?: MemberRole | 'author';
  organisations?: {
    [orgId: string]: IMember;
  };
  projectAdminAccess?: string[];
  hasAuthorProfile?: boolean;
  platformAdminRole?: Extract<MemberRole, 'superAdmin' | 'admin'>;
}

/** True when auth hydration rebuilt an equivalent user object. */
export function isSameStoredUser(
  current: StoredUserSnapshot | null,
  next: StoredUserSnapshot
): boolean {
  if (!current) return false;
  if (
    current.userId !== next.userId ||
    current.userRole !== next.userRole ||
    current.email !== next.email ||
    current.displayName !== next.displayName ||
    current.hasAuthorProfile !== next.hasAuthorProfile ||
    current.platformAdminRole !== next.platformAdminRole
  ) {
    return false;
  }

  const currentProjectAccess = current.projectAdminAccess?.join(',') ?? '';
  const nextProjectAccess = next.projectAdminAccess?.join(',') ?? '';
  if (currentProjectAccess !== nextProjectAccess) return false;

  const currentOrgIds = current.organisations ? Object.keys(current.organisations).join(',') : '';
  const nextOrgIds = next.organisations ? Object.keys(next.organisations).join(',') : '';
  return currentOrgIds === nextOrgIds && current.organisations === next.organisations;
}
